import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useRoute, useRouter } from 'vue-router'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { computed, onBeforeMount, reactive, ref } from 'vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import type { LbuSaleCoachingParams, LbuSaleCoachingListItem } from '@/typings/api/saleCoaching'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { statusEnum } from './dataConfig'
import { saleCoachingList, saleCoachingDelete, saleCoachingConfirm } from '@/api/yuntuSales/saleCoaching'
import Modal from '@/hooks/modalType'
import { shareInfo } from '@dc-platform/dc-interaction'
import { customerListFormat, getTreeNameList } from '@/utils'
import { cloneDeep } from 'lodash-es'
import useHook from '@/components/CustomerAreaCascader/useHook'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'


const __default__ = { name: 'DcCosLbuSaleCoaching' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const tableRef = ref()
const searchFrom = reactive<any>({})
onBeforeMount(() => {
  if (route.query.queryParams) {
    const queryParams = JSON.parse(route.query.queryParams as any)
    console.log(queryParams)
    if (queryParams) {
      const status = queryParams.status
      if (status) {
        searchFrom.status = status
      }
      const tutoringStartTime = queryParams.tutoringStartTime
      if (tutoringStartTime) {
        searchFrom.tutoringStartTime = tutoringStartTime
      }
      const tutoringEndTime = queryParams.tutoringEndTime
      if (tutoringEndTime) {
        searchFrom.tutoringEndTime = tutoringEndTime
      }
      const mentorList = queryParams.mentorList
      if (mentorList) {
        searchFrom.mentorList = mentorList
      }
    }
  }
})

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const handledQueryParams = (params: any) => {
  const queryParams = cloneDeep(params)
  const mentors = queryParams.mentorList
  if (mentors && mentors.length === 1) {
    queryParams.mentor = mentors[0]
    delete queryParams.mentorList
  }
  return queryParams
}
const fetch = (searchFrom: LbuSaleCoachingParams, callBack: (res: any) => void) => {
  const queryForm = handledQueryParams(searchFrom)
  saleCoachingList(queryForm).then((res) => {
    callBack(res)
  })
}

const columns = computed(() => [
  {
    title: 'ID',
    dataIndex: 'id',
    cosType: 'link',
    path: '/lbu/saleCoaching/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '辅导人', dataIndex: 'mentorName' },
  { title: '辅导人区域', dataIndex: 'mentorRegion' },
  { title: '被辅导人', dataIndex: 'traineeName' },
  { title: '被辅导人区域', dataIndex: 'traineeRegion' },
  { title: '本次辅导时间', dataIndex: 'tutoringTime' },
  { title: '状态', dataIndex: 'status', dicData: statusEnum },
  { title: '重点关注指标', dataIndex: 'focusArea' },
  // { title: '目标设定', dataIndex: 'target' },
  { title: '回顾时间', dataIndex: 'reviewTime' },
  // { title: '执行结果', dataIndex: 'executionResult' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])

const handleQueryChange = () => {
  tableRef.value?.search()
}

const addRow = (row: LbuSaleCoachingListItem) => {
  router.push('/lbu/saleCoaching/add')
}

const editRow = (row: LbuSaleCoachingListItem) => {
  router.push({
    path: '/lbu/saleCoaching/edit',
    query: {
      id: row.id
    }
  })
}

const deleteRow = (row: LbuSaleCoachingListItem) => {
  Modal.delete({
    name: row.id,
    onOk() {
      saleCoachingDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

const confirmRow = (row: LbuSaleCoachingListItem) => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      saleCoachingConfirm({ id: row.id }).then(() => {
        DcMessage.success('操作成功')
        tableRef.value.fetch()
      })
    }
  })
}

const reviewRow = (row: LbuSaleCoachingListItem) => {
  router.push({
    path: '/lbu/saleCoaching/review',
    query: {
      id: row.id
    }
  })
}

const commentRow = (row: LbuSaleCoachingListItem) => {
  router.push({
    path: '/lbu/saleCoaching/comment',
    query: {
      id: row.id
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              columns: columns.value,
              tableId: "lbuSaleCoachingRecord",
              search: searchFrom,
              "onUpdate:search": _cache[12] || (_cache[12] = ($event: any) => ((searchFrom) = $event)),
              onFetch: fetch,
              ref_key: "tableRef",
              ref: tableRef
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: searchFrom }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: searchFrom.status,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.status) = $event)),
                          optionType: "button",
                          options: _unref(statusEnum),
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange()))
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "辅导人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          permission: "",
                          value: searchFrom.mentorList,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.mentorList) = $event)),
                          mode: "multiple",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "被辅导人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          permission: "",
                          value: searchFrom.trainee,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.trainee) = $event)),
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "本次辅导时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_cos_range_picker, {
                          startTime: searchFrom.tutoringStartTime,
                          "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.tutoringStartTime) = $event)),
                          endTime: searchFrom.tutoringEndTime,
                          "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.tutoringEndTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "辅导人区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_lbu",
                          ids: searchFrom.mentorRegionList,
                          "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.mentorRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "被辅导人区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_lbu",
                          ids: searchFrom.traineeRegionList,
                          "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.traineeRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "回顾时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_cos_range_picker, {
                          startTime: searchFrom.reviewStartTime,
                          "onUpdate:startTime": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.reviewStartTime) = $event)),
                          endTime: searchFrom.reviewEndTime,
                          "onUpdate:endTime": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom.reviewEndTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "id",
                      label: "ID"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchFrom.id,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchFrom.id) = $event)),
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: addRow
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 新增 ")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_sale_coaching_add_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_lbu",
                  taskType: "310",
                  search: handledQueryParams(searchFrom)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出")
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'lbu_sale_coaching_export_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (handleExportDetails()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出明细")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_sale_coaching_details_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'mentorRegion' || column.dataIndex === 'traineeRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 0,
                      appId: "cos_lbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_MoreButton, { key: 1 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.status === 2,
                          onClick: ($event: any) => (editRow(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 编辑 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_sale_coaching_edit_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (deleteRow(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 删除 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'lbu_sale_coaching_del_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.status === 2,
                          onClick: ($event: any) => (confirmRow(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确认 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_sale_coaching_confirm_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.status !== 2 || record.reviewTime != undefined || _unref(shareInfo).getUserInfo().work_code !== record.mentor,
                          onClick: ($event: any) => (reviewRow(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 回顾 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_sale_coaching_review_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.status !== 2,
                          onClick: ($event: any) => (commentRow(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 评论 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_sale_coaching_comment_btn']
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ExportDetails, {
      ref_key: "exportDetailsRef",
      ref: exportDetailsRef,
      appId: "cos_lbu",
      search: searchFrom,
      taskTypeEnum: [
  { value: 331, label: '关注指标和项目' },
  { value: 332, label: '行动计划' },
  { value: 333, label: '回顾明细' }
]
    }, null, 8, ["search"])
  ], 64))
}
}

})